import {DefaultNavTextFieldProps} from '@models/DefaultProps.ts';
import {OpenInNew} from '@mui/icons-material';
import {IconButton, TextField, Tooltip} from '@mui/material';
import React from 'react';
import {useNavigate} from 'react-router';

export interface TextFieldNavProps<T = any, TMode = never | keyof T, TToolTip = keyof T | undefined | never> extends DefaultNavTextFieldProps<T, TMode, TToolTip> {
}

export const TextFieldNav: React.FC<TextFieldNavProps> = (props) => {
	const {
		slotProps: {textField} = {},
		label,
		displayValue,
		displayMode,
		value,
		pathName,
		searchData,
	} = props;
	const navigate = useNavigate();
	const location = window.location;
	
	const textFieldProps: Partial<React.ComponentProps<typeof TextField>> = {
		...textField,
		fullWidth: true,
		label: label || 'Link',
		disabled: true,
		value: displayValue || (displayMode && value && value[displayMode]) || '',
		slotProps: {
			input: {
				endAdornment: <IconButton onClick={() => {
					navigate({
						pathname: pathName,
						search: new URLSearchParams({...searchData}).toString(),
					});
				}}
				                          disabled={location.pathname === pathName && new URLSearchParams({...searchData}).toString() === location.search.slice(1)}
				>
					<OpenInNew/>
				</IconButton>,
			},
		},
	};
	
	return (
		<Tooltip title={(value && props.tooltip && value[props.tooltip]) ?? ''}>
			<TextField {...textFieldProps}/>
		</Tooltip>
	);
};
